export default {
  id: "Form #", // 864-50-109",
  label: "Name", //Bradington-Young",
  description: "Description", //Bradington-Young",
  type: false, // "Type", //"Hotspot",
  cover: false, // "Cover", // "Bradington-Young",
  position: false, // "Position", // 0,
  createdOn: "Created On", //"2012-10-09T23:00:00.0000000Z",
  createdBy: "Created By",
  refId: "Ref ID",
  modifiedOn: "Modified On", //"2012-10-09T23:00:00.0000000Z",
  publishOn: "Publish On", //"2012-10-09T23:00:00.0000000Z",
  expiresOn: "Expires On", //"9998-11-30T23:00:00.0000000Z",
  active: "Status", //true,
  vendorId: false, //"",
  tags: "Tags", // [],
  layout: false, //"Layout"

  ///actions
  autoHotspotAllFormioPages: "Auto-Hotspot All Formio Pages...",
  autoHotspotSKUs: "Auto-Hotspot SKUs...",
  editFormioProperties: "Edit Formio Properties...",
  editPageProperties: "Edit Page Properties...",
  shareProductsOnPage: "Share Products on Page...",
  managePage: "Manage Page...",
  manageProducts: "Manage Products...",
  manageMedia: "Manage Media...",
  viewYouTubeVideos: "View YouTube Videos...",
  viewPageOverview: "View YouTube Videos...",
  createMultiItemHotspot: "Create a new multi-item hotspot",
  createExternalResource: "Link to an External Resource",
  createYouTubeHotspot: "Create a YouTube hotspot",
  createVideoHotspot: "Create a video hotspot",
};
